export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/raptorize-8d7c71982981aa0936ec57209449e930.jpg";